import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { selectedTurnItem } from '../shared/selected.turn.items';

const useHandleTurnBaseLogic = (
  setSelectedTurn,
  setTurnBase,
  turnBase,
  turnBaseData
) => {
  const [, setSelectedTurnItem] = useAtom(selectedTurnItem);

  useEffect(() => {
    setSelectedTurn();
    setTurnBase();
  }, []);

  useEffect(() => {
    if (
      turnBaseData?.serviceBased?.length === 1 &&
      turnBaseData?.specialityBased?.length === 1
    ) {
      if (turnBase === 'service') {
        setSelectedTurnItem(turnBaseData?.serviceBased[0]);
        return;
      }
      if (turnBase === 'speciality') {
        setSelectedTurnItem(
          turnBaseData?.specialityBased[0]
        );
        return;
      }
    }
  }, [turnBase]);
};

export default useHandleTurnBaseLogic;
